import React from "react";
import { Globe, Clapperboard, Share2 } from "lucide-react";
import { TwinneeWordmark } from "@/components/TwinneeWordmark";

export const FooterSection = () => {
  const pub = process.env.PUBLIC_URL || "";
  return (
    <footer className="text-white py-16 px-4 sm:px-6 lg:px-8 font-sora relative z-10 bg-[#131313]">
      <div className="max-w-5xl mx-auto">
        {/* Logo & Tagline */}
        <div className="text-center pb-10 border-b border-white/10">
          <div className="flex items-center justify-center mb-3">
            <TwinneeWordmark className="h-10" />
          </div>
          <p className="text-white text-base font-semibold">"Your movie. Just click."</p>
        </div>

        {/* Links Grid */}
        <div className="grid grid-cols-3 gap-10 py-10 border-b border-white/10 max-w-2xl mx-auto">
          <div>
            <h4 className="text-[10px] font-bold uppercase tracking-widest mb-4 bg-gradient-to-r from-[#D0BCFF] to-[#62FAE3] bg-clip-text text-transparent">Product</h4>
            <ul className="space-y-3 text-sm text-gray-300 font-light">
              <li><a href="#flows" className="hover:text-white transition-colors">How it works</a></li>
              <li><a href="#showcase" className="hover:text-white transition-colors">Gallery</a></li>
              <li><a href="#pricing" className="hover:text-white transition-colors">Pricing</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-[10px] font-bold uppercase tracking-widest mb-4 bg-gradient-to-r from-[#D0BCFF] to-[#62FAE3] bg-clip-text text-transparent">Support</h4>
            <ul className="space-y-3 text-sm text-gray-300 font-light">
              <li><a href="#faq" className="hover:text-white transition-colors">FAQ</a></li>
              <li><a href="mailto:support@twinnee.com" className="hover:text-white transition-colors">Talk to us</a></li>
            </ul>
          </div>
          <div>
            <h4 className="text-[10px] font-bold uppercase tracking-widest mb-4 bg-gradient-to-r from-[#D0BCFF] to-[#62FAE3] bg-clip-text text-transparent">Company</h4>
            <ul className="space-y-3 text-sm text-gray-300 font-light">
              <li><a href="/about" className="hover:text-white transition-colors">About</a></li>
              <li><a href="/privacy" className="hover:text-white transition-colors">Privacy</a></li>
            </ul>
          </div>
        </div>

        {/* CTA Banner */}
        <div className="my-8 rounded-2xl border border-white/10 bg-[#131313] px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-5">
          <div>
            <h3 className="text-lg sm:text-xl font-bold text-white">Ready for the spotlight?</h3>
            <p className="text-xs text-gray-400 font-light mt-1">Join 10k+ creators making cinematic AI videos today.</p>
          </div>
          <a href="/register" className="shrink-0 px-6 py-3 rounded-full font-semibold text-sm bg-gradient-to-r from-[#8B6FCC] via-[#3ABFB0] to-[#2AA89A] text-white hover:brightness-110 hover:scale-105 transition-all duration-200 active:scale-95 cursor-pointer whitespace-nowrap">
            Start Creating
          </a>
        </div>

        <div className="border-t border-white/10" />
        <div className="pt-4 flex flex-col sm:flex-row items-center justify-between text-xs text-gray-500 font-light gap-4">
          <p>© {new Date().getFullYear()} Twinnee. Made with care in India.</p>
          <div className="flex items-center gap-4">
            <a href="#" className="hover:text-white transition-colors" aria-label="Website"><Globe className="w-4 h-4" /></a>
            <a href="#" className="hover:text-white transition-colors" aria-label="Videos"><Clapperboard className="w-4 h-4" /></a>
            <a href="#" className="hover:text-white transition-colors" aria-label="Share"><Share2 className="w-4 h-4" /></a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
